import _typeof from "@babel/runtime/helpers/typeof";

/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var numberList = "";
  var count = 0;

  var addmoreButton = function addmoreButton() {
    for (var i = 0; i < 5; i++) {
      if (count >= 30) {
        if (window.lang == "en") $f7.dialog.alert("Max bet is 30 rows");
        if (window.lang == "tl") $f7.dialog.alert("Jogadór másimu hamutuk 30");
        return;
      }

      addmore();
    }
  };

  var addmore = function addmore(number, amount1, amount2, amount3) {
    count++;
    var autofocus = "";
    if (count == 1) autofocus = "autofocus";
    var disable1 = "disabled";
    var disable2 = "disabled";
    var disable3 = "disabled";
    if (number == undefined || _typeof(number) === 'object') number = "";

    if (number.length == 4) {
      disable1 = "";
      disable2 = "";
      disable3 = "";
    }

    if (number.length == 3) {
      disable2 = "";
      disable3 = "";
    }

    if (number.length == 2) {
      disable3 = "";
    }

    var selected = "";

    if (number.includes("**")) {
      number = number.replace("**", "");
      selected = "selected"; // `+selected+`
    }

    numberList = "\n        <ul>\n          <li class=\"item-content item-input item-input-outline\">\n            <div class=\"item-inner\">\n              <div class=\"item-input-wrap input-dropdown-wrap\" style=\"width:90px\">\n                <select placeholder=\"Please choose...\" id=\"numberTypeSG" + count + "\" " + autofocus + ">\n                  <option value=\"\">\n                    Langsung\n                  </option>\n                  <!--option value=\"*\">Box</option-->\n                  <option value=\"**\"  " + selected + ">\n                    Sistema\n                  </option>\n                </select>\n              </div>\n              <div class=\"item-input-wrap\" style=\"width:80px\">\n                <input type=\"number\" pattern=\"\\d*\" maxlength = \"4\" oninput=\"javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);\" placeholder=\"- - - -\" name=\"" + count + "\" id=\"numberSG1_" + count + "\" class=\"myNumberSG\" value=\"" + number + "\"/>\n              </div>\n              <div class=\"item-input-wrap\" style=\"width:60px\">\n                <input type=\"number\" pattern=\"\\d*\" maxlength = \"4\" oninput=\"javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);\" placeholder=\"0\" name=\"" + count + "\" id=\"numberSG2_" + count + "\" class=\"myNumberSG\"  value=\"" + amount1 + "\" " + disable1 + "/>\n              </div>\n              <div class=\"item-input-wrap\" style=\"width:60px\">\n                <input type=\"number\" pattern=\"\\d*\" maxlength = \"4\" oninput=\"javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);\" placeholder=\"0\" name=\"" + count + "\" id=\"numberSG3_" + count + "\" class=\"myNumberSG\"  value=\"" + amount2 + "\" " + disable2 + "/>\n              </div>\n              <div class=\"item-input-wrap\" style=\"width:60px\">\n                <input type=\"number\" pattern=\"\\d*\" maxlength = \"4\" oninput=\"javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);\" placeholder=\"0\" name=\"" + count + "\" id=\"numberSG4_" + count + "\" class=\"myNumberSG\" value=\"" + amount3 + "\" " + disable3 + "/>\n              </div>\n            </div>\n          </li>\n        </ul>\n  \n      ";
    $('.number-list').append(numberList);
    $update();
  };

  var send = function send() {
    window.copy = false;
    window.origin = "bet"; //Verify if empty

    if ($("#remarks").val() == "" && $("#smsnum").val() == "" && window.service != "web" && window.service != "cashier") {
      if (window.service == "agent") {
        if (window.lang == "tl") $f7.dialog.alert("Canal fan/sosa nian presija GDp/numeru telemovel ba bilhete atu sai nudar protesaun");
        if (window.lang == "en") $f7.dialog.alert("This Sales Channel is Required GDP/Mobile Number fo Ticket Protection");
        if (window.lang == "cn") $f7.dialog.alert("请提供GDP/手机号码，用于票根保护");
        return;
      }

      if (window.service == "kiosk") {
        if (confirm('If no GDP inserted, then No Qualified for Jackpot and No Points Colletion. Do you want to continue?')) {} else {
          return;
        }
      }
    }

    if ($("#remarks").val() != "") {
      var maxdigit = 20;
      var mindigit = 6;

      if ($("#remarksCountry").val() == "+670") {
        maxdigit = 8;
        mindigit = 8;
      }

      if ($("#remarks").val().length > maxdigit || $("#remarks").val().length < mindigit) {
        if (window.lang == "en") $f7.dialog.alert("Phone must have at least " + mindigit + " to " + maxdigit + " digits");
        if (window.lang == "tl") $f7.dialog.alert("Numeru Telemovel tenke to " + mindigit + " to'o " + maxdigit);
        return;
      }
    }

    if ($("#smsnum").val() != "") {
      if ($("#smsnum").val().length < 6) {
        $f7.dialog.alert("Test Code must have at least 6 digits");
        return;
      }
    }

    var dataframe = "";

    if (window.service != "web") {
      dataframe = "D";

      for (var i = 1; i <= 8; i++) {
        if ($("#dateSG" + i).is(':checked')) {
          dataframe += "%23" + $("#dateSG" + i).val();
        }
      }
    } //GD Provider 8 SG Provider 4


    dataframe += "%0D%0A" + "%23" + "4";
    window.orderEntry = "QR:5:" + $("#remarksCountry").val() + ":" + $("#remarks").val() + ":#4";

    if ($("#provider2").is(':checked')) {
      dataframe += "8";
      window.orderEntry += "#8";
    }

    var empty = true;

    for (var i = 1; i <= count; i++) {
      var num1 = $("#numberSG1_" + i).val();
      var num2 = $("#numberSG2_" + i).val();
      var num3 = $("#numberSG3_" + i).val();
      var num4 = $("#numberSG4_" + i).val();
      var box = $("#numberTypeSG" + i).val();

      if (num1 != "") {
        if (num2 != "" && (num2 < 0.25 || num2 > 100)) {
          $f7.dialog.alert("Montante osan ba jogu hahu husi $0.25 to $100 ba joga <br/><br/> Amount must be in between $0.25 to $100 for bet " + num1);
          return;
        }

        if (num3 != "" && (num3 < 0.25 || num3 > 100)) {
          $f7.dialog.alert("Montante osan ba jogu hahu husi $0.25 to $100 ba joga <br/><br/> Amount must be in between $0.25 to $100 for bet " + num1);
          return;
        }

        if (num4 != "" && (num4 < 0.25 || num4 > 100)) {
          $f7.dialog.alert("Montante osan ba jogu hahu husi $0.25 to $100 ba joga <br/><br/> Amount must be in between $0.25 to $100 for bet " + num1);
          return;
        }

        if (num1.length == 4) {
          if (num2 == "") {
            $f7.dialog.alert("4D amount cannot be empty");
            return;
          }
        }

        if (num1.length == 3) {
          if (num3 == "") {
            $f7.dialog.alert("3D amount cannot be empty");
            return;
          }
        } //if(num2.includes(".")) {$f7.dialog.alert("Must be round number 1-100 for bet " + num1);return;}
        //if(num3.includes(".")) {$f7.dialog.alert("Must be round number 1-100 for bet " + num1);return;}
        //if(num4.includes(".")) {$f7.dialog.alert("Must be round number 1-100 for bet " + num1);return;}


        if (num2 == "" && num3 == "" && num4 == "") {
          if (window.lang == "tl") $f7.dialog.alert("Favor prienxe ita nia montante osan " + num1);
          if (window.lang == "en") $f7.dialog.alert("Please fill amount for " + num1);
          if (window.lang == "cn") $f7.dialog.alert("请输入" + num1 + "的金额");
          return;
        }
      }

      if (num1 != "") {
        window.orderEntry += "|" + num1 + "#" + num2 + "#" + num3 + "#" + num4;
        empty = false;
        if (num1.length == 4) dataframe += "%0D%0A" + box + num1 + "%23" + num2 + "%23%23%23" + num3 + "%23" + num4;
        if (num1.length == 3) dataframe += "%0D%0A" + box + num1 + "%23" + num3 + "%23" + num4;
        if (num1.length == 2) dataframe += "%0D%0A" + box + num1 + "%23" + num4;
      }
    }

    if (empty == true) {
      if (window.lang == "tl") $f7.dialog.alert("Favor prienxe ita nia numeru");
      if (window.lang == "en") $f7.dialog.alert("Please fill in bet number");
      if (window.lang == "cn") $f7.dialog.alert("请输入投注号码");
      return;
    }

    if (window.service == "web") {
      window.book = dataframe;
      window.form = 5;
      $f7.views.main.router.navigate("/web_qr/");
      return;
    }

    if (window.service == "kiosk-closed") {
      //$f7.views.main.router.navigate("/kiosk_receipt/");  
      window.print_detail = "<CENTER><H1>Print your order</H1></CENTER>";
      window.print_text = "{CENTER}";
      window.print_text += "{BR}{BR}";
      window.print_text += "Please show this receipt to the cashier to make payment";
      window.print_text += "{BR}{BR}";
      window.print_qr = window.orderEntry;
      window.print_page = "/kiosk_home/";
      $f7.views.current.router.navigate("/gen_receipt/");
      return;
    }

    console.log(dataframe);
    console.log(window.orderEntry);
    $f7.request({
      method: 'get',
      url: window.waypoint + 'order.aspx',
      data: {
        form: 5,
        currency: window.currency,
        smsnum: $("#remarksCountry").val() + "-" + $("#remarks").val(),
        remarks: $("#smsnum").val(),
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot,
        bet: dataframe
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        var data = JSON.parse(data);
        console.log(data);

        if (data.ALERT != undefined && data.ALERT != "") {
          $f7.dialog.alert(data.ALERT);
        }

        if (data.status == "1") {
          window.kiosk = data;
          window.isPrint = true;

          if (window.service == "agent" || window.service == "cashier") {
            window.orderId = window.kiosk.orderId;
            window.origin = "bet";
            $f7.views.current.router.navigate("/cashier_receipt/");
          }

          if (window.service == "kiosk") {
            $f7.views.main.router.navigate("/kiosk_receipt/");
          }
        } else {
          var errorMsg = data.errmsg;
          if (errorMsg == "ERR_INVALID_NUMBER") errorMsg = "Please fill in four number";
          if (errorMsg == "ERR_INVALID_AMOUNT") errorMsg = "Please fill in amount";
          $f7.dialog.alert(errorMsg);
        }
      }
    });
  };

  $on('pageAfterIn', function () {
    $f7.toolbar.hide(".toolbar-app");
  });
  $on('pageAfterOut', function () {
    $f7.toolbar.show(".toolbar-app");
  });

  var lucky = function lucky() {
    for (var i = 1; i <= count; i++) {
      var val = Math.floor(1000 + Math.random() * 9000);
      $('#numberSG1_' + i).val(val);
      $('#numberSG1_' + i).focus();
      $('#numberSG1_' + i).keyup();
    }
  };

  var fav_list = "";

  var fav_list_it = function fav_list_it() {
    fav_list = "";
    $(".fav-list").html("");
    var codeEnter = localStorage.getItem("fav");

    if (codeEnter == "" || codeEnter == undefined || codeEnter == null || codeEnter == "null") {
      return;
    }

    var arr = codeEnter.split(":");

    for (var i = arr.length - 1; i >= 0; i--) {
      if (arr[i] != "null") fav_list += "\n            <tr>\n              <td class=\"label-cell\">" + arr[i] + "</td>\n              <td class=\"numeric-cell\">\n              </td>  \n              <td class=\"numeric-cell\">\n                <div class=\"segmented\">\n                <a href='#' class=\"button button-fill button-small button-fav-insert\" id=\"" + arr[i] + "\">Select</a>\n                <a href='#' class=\"button button-outline button-small button-fav-delete\" id=\"" + arr[i] + "\">Delete</a>\n                </div>              </td>\n            </tr>\n        ";
      $(".fav-list").html(fav_list);
    }
  };

  var fav_add = function fav_add() {
    var dialog = $f7.dialog.prompt('Enter new number', function (name) {
      if (name == "") {
        $f7.dialog.alert("Number cannot be empty");
      } else $f7.dialog.confirm('Are you sure to save ' + name + '?', function () {
        localStorage.setItem("fav", localStorage.getItem("fav") + ":" + name);
        fav_list_it();
      });
    });
    dialog.$el.find('input').attr('type', 'number');
  };

  var fav_delete = function fav_delete(name) {
    $f7.dialog.confirm('Are you sure to delete ' + name + '?', function () {
      var data = localStorage.getItem("fav");
      data = data.replace(":" + name, "");
      localStorage.setItem("fav", data);
      fav_list_it();
    });
  };

  $on('pageInit', function () {
    // Handle Fav Number Begin
    fav_list_it();
    $f7.sheet.create({
      el: '.my-sheet-swipe-to-close',
      swipeToClose: true,
      backdrop: true
    });
    $(document).on("click", ".button-fav-insert", function (e) {
      e.stopImmediatePropagation();
      console.log("click");
      $("#remarks").val(e.srcElement.id);
      $("#remarks").focus();
      $f7.sheet.close('.my-sheet-swipe-to-close');
    });
    $(document).on("click", ".button-fav-delete", function (e) {
      e.stopImmediatePropagation();
      fav_delete(e.srcElement.id);
    }); // Handle Fav Number End

    count = 0;
    $(document).on('keyup', '.myNumberSG', function (e) {
      e.stopImmediatePropagation();

      if (document.activeElement.id.includes("1_") || document.activeElement.id.includes("remarks") || document.activeElement.id.includes("smsnum")) {
        var valCheck = $("#" + document.activeElement.id).val().replace(".", ""); //$("#" + document.activeElement.id).val('');
        //$("#" + document.activeElement.id).val(valCheck);
      } else {
        var valCheck = parseInt($("#" + document.activeElement.id).val()); //$("#" + document.activeElement.id).val('');
        //$("#" + document.activeElement.id).val(valCheck);
      }

      if (e.key == "Enter") {
        var inputs = document.getElementsByClassName('myNumberSG');

        for (var i = 0; i < inputs.length; i++) {
          if (document.activeElement.id == inputs[i].id) {
            for (var j = i + 1; j < inputs.length; j++) {
              if (!inputs[j].disabled) {
                inputs[j].focus();
                break;
              }
            }

            break;
          }
        }
      }

      if ($('#numberSG1_' + e.srcElement.name).val() == undefined) return;
      console.log('input value changed for ' + e.srcElement.name + $('#numberSG1_' + e.srcElement.name).val().length);

      if ($('#numberSG1_' + e.srcElement.name).val().length <= 1) {
        document.getElementById("numberSG2_" + e.srcElement.name).disabled = true;
        document.getElementById("numberSG3_" + e.srcElement.name).disabled = true;
        document.getElementById("numberSG4_" + e.srcElement.name).disabled = true;
      }

      if ($('#numberSG1_' + e.srcElement.name).val().length == 2) {
        document.getElementById("numberSG2_" + e.srcElement.name).disabled = true;
        document.getElementById("numberSG3_" + e.srcElement.name).disabled = true;
        document.getElementById("numberSG4_" + e.srcElement.name).disabled = false;
      }

      if ($('#numberSG1_' + e.srcElement.name).val().length == 3) {
        document.getElementById("numberSG2_" + e.srcElement.name).disabled = true;
        document.getElementById("numberSG4_" + e.srcElement.name).disabled = false;
        document.getElementById("numberSG3_" + e.srcElement.name).disabled = false;
      }

      if ($('#numberSG1_' + e.srcElement.name).val().length == 4) {
        document.getElementById("numberSG4_" + e.srcElement.name).disabled = false;
        document.getElementById("numberSG3_" + e.srcElement.name).disabled = false;
        document.getElementById("numberSG2_" + e.srcElement.name).disabled = false;
      }
    });
    if (window.service != "web") $f7.request({
      method: 'get',
      url: window.waypoint + 'drawdates.aspx',
      data: {
        drawtype: 4,
        form: 5,
        latitude: window.lat,
        longitude: window.lot,
        action: "none"
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        console.log("Output:" + data);
        data = JSON.parse(data);
        var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        for (var i = 0; i < data.drawDates.length; i++) {
          var drawarr = String(data.drawDates[i].date).split("-");
          console.log(drawarr[1]);
          $("#dateSG" + (i + 1)).val(("0" + drawarr[1]).slice(-2) + "" + ("0" + drawarr[2]).slice(-2));
          $(".dateSG" + (i + 1)).html(drawarr[2] + " " + months[parseInt(drawarr[1]) - 1]);
        }
      }
    }); // const d = new Date();
    // const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    // // After 7.00 GTM+8 set another day
    // if(d.getUTCHours + 8 >= 1900) d.setDate(d.getDate() + 1);
    // for(var i=1; i <= 8;i++)
    // {
    //   // ONLYE CERTAIN DAY FOR GAME
    //   if(d.getDay() != 3 && d.getDay() != 6 && d.getDay() != 7)
    //   {
    //     i--;
    //     d.setDate(d.getDate() + 1);
    //     continue;
    //   }
    //   $(".date" + i).html(d.getDate() + " " + months[d.getMonth()]);
    //   $().name
    //   $("#date" + i).val(("0" + (d.getMonth() + 1)).slice(-2) + "" + ("0" + d.getDate()).slice(-2));
    //   console.log($("#date" + i).val());
    //   d.setDate(d.getDate() + 1);
    // }

    numberList = "\n        <ul>\n          <li class=\"item-content item-input item-input-outline\" style=\"background-color:var(--f7-theme-color);border-top-left-radius: 10px;border-top-right-radius: 10px;font-size: 16px;font-weight: 700;height: 32px;\">\n            <div class=\"item-inner\">\n              <div  style=\"width:90px;text-align:center\">\n                \n                  <span class='en'>TYPE</span>\n                  <span class='cn'>\u7C7B\u578B</span>\n                  <span class='tl'>TIPU</span>\n                \n              </div>\n              <div  style=\"width:80px;text-align:center\">\n                \n                  <span class='en'>NUMBER</span>\n                  <span class='cn'>\u53F7\u7801</span>\n                  <span class='tl'>NUMERU</span>\n                \n              </div>\n              <div  style=\"width:60px;text-align:center\">\n                4D\n              </div>\n              <div style=\"width:60px;text-align:center\">\n                3D\n              </div>\n              <div style=\"width:60px;text-align:center\">\n                2D\n              </div> \n          </li>\n        </ul>  \n      ";
    $('.number-list').append(numberList);

    if (window.origin == "rebuy") {
      // for(var i=0;i < window.data.receipt.length;i++)
      // {
      //   for(var j=0;j < window.data.receipt[i].details.length;j++)
      //   {
      //     var a1,a2,a3;
      //     if(window.data.receipt[i].details[j].amount[0]) a1 = window.data.receipt[i].details[j].amount[0].value;
      //     if(window.data.receipt[i].details[j].amount[1]) a2 = window.data.receipt[i].details[j].amount[1].value;
      //     if(window.data.receipt[i].details[j].amount[2]) a3 = window.data.receipt[i].details[j].amount[2].value;
      //     addmore(window.data.receipt[i].details[j].number,a1,a2,a3);
      //   }
      // }
      window.origin = "";
      $("#remarks").val(window.data.smsnum.substring(5));
      $("#remarksCountry").val(window.data.smsnum.substring(0, 4));
      var arr = window.data.orderEntry.split("|");
      if (arr[0].includes("8")) document.getElementById("provider2").checked = true;

      for (var i = 1; i < arr.length; i++) {
        var bet = arr[i].split("#");
        addmore(bet[0], bet[1], bet[2], bet[3]);
      }
    } else {
      for (var i = 0; i < 5; i++) {
        addmore();
      }
    }

    if (window.service == "web") {
      $(".web-sg").hide();
    }

    var dataCountry = JSON.parse(window.country);
    var htmlCountry = "";
    var code = "";
    var selected = "";

    for (var i = 0; i < dataCountry.length; i++) {
      if (dataCountry[i].code == "+670") selected = "selected='selected'";else selected = "";
      if (code != dataCountry[i].code) htmlCountry += '<option value="' + dataCountry[i].code + '" ' + selected + '>' + dataCountry[i].id + " " + dataCountry[i].code + '</option>';
      code = dataCountry[i].code;
    }

    $("#remarksCountry").html(htmlCountry);
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="about">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        <div class="left">
          <a href="#" class="link back">
            <i class="icon icon-back"></i>
            <span class="if-not-md">
              <span class='en'>Back</span>
              <span class='cn'>返回</span>
              <span class='tl'>Fila</span>
            </span>
          </a>
        </div>
        <div class="title">
          <img src="static/images/sg.png" width="30px" style="vertical-align:middle"/>
          <span style="margin-left:10px;">SG Toto 4D,3D,2D</span>
        </div>
      </div>
    </div>
    
    <div class="page-content">
    
      <!-- THIS IS THE DATE BEGIN -->
      <div class="block web-sg">
        <div class="row">
          <div class="col">
            <label class="item-checkbox item-content" style="white-space: nowrap;">
              <input type="checkbox" id="dateSG1" checked/>
              <i class="icon icon-checkbox"></i>
              <label style="margin-left: -7px;" for="dateSG1" class="dateSG1">d MM</label>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content" style="white-space: nowrap;">
              <input type="checkbox" id="dateSG2"/>
              <i class="icon icon-checkbox"></i>
              <label style="margin-left: -7px;" for="dateSG2" class="dateSG2">d MM</label>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content" style="white-space: nowrap;">
              <input type="checkbox" id="dateSG3"/>
              <i class="icon icon-checkbox"></i>
              <label style="margin-left: -7px;" for="dateSG3" class="dateSG3">d MM</label>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content" style="white-space: nowrap;">
              <input type="checkbox" id="dateSG4"/>
              <i class="icon icon-checkbox"></i>
              <label style="margin-left: -7px;" for="dateSG4" class="dateSG4">d MM</label>
            </label>
          </div>
        </div>
        <br/>
        <div class="row" style="display: none;">
          <div class="col">
            <label class="item-checkbox item-content" style="white-space: nowrap;">
              <input type="checkbox" id="dateSG5"/>
              <i class="icon icon-checkbox"></i>
              <label style="margin-left: -7px;" for="dateSG5" class="dateSG5">d MM</label>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content" style="white-space: nowrap;">
              <input type="checkbox" id="dateSG6"/>
              <i class="icon icon-checkbox"></i>
              <label style="margin-left: -7px;" for="dateSG6" class="dateSG6">d MM</label>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content" style="white-space: nowrap;">
              <input type="checkbox" id="dateSG7"/>
              <i class="icon icon-checkbox"></i>
              <label style="margin-left: -7px;" for="dateSG7" class="dateSG7">d MM</label>
            </label>
          </div>
          <div class="col">
            <label class="item-checkbox item-content" style="white-space: nowrap;">
              <input type="checkbox" id="dateSG8"/>
              <i class="icon icon-checkbox"></i>
              <label style="margin-left: -7px;" for="dateSG8" class="dateSG8">d MM</label>
            </label>
          </div>
        </div>
      </div>
      <!-- DATE END HERE -->
      
  
  

  
      <!-- WHERE THE NUMBER KEY IN START -->
      <div class="list inline-labels no-hairlines-md number-list">
  
      </div>
      <!-- WHERE THE NUMBER KEY IN END -->

      <!-- ENTER PHONE NUMBER AND OPTION FOR OTHER PROVIDER START -->
      


          <div class="list no-hairlines no-hairlines-between web-sg" style="margin-left:0px;background-color: transparent;margin-top: -30px;">
            <ul style="background-color:transparent">
              <li class="item-content item-input item-input-outline">
                <div class="item-inner" style="width: 40%;">
                  <div class="item-title item-floating-label"></div>
                  <div class="item-input-wrap input-dropdown-wrap">
                    <select id="remarksCountry" class="myNumberSG">
                      <option value="+670" selected="selected">+670</option>
                    </select>
                  </div>
                </div>
                <div class="item-inner">
                                <div class="item-title item-floating-label">
                <span class='en'>Phone</span>
                <span class='cn'>电话</span>
                <span class='tl'>Telemovel</span>
              </div>
                  <div class="item-input-wrap">
                    <div class="row">
                      <div class="col-80">
                        <input type="tel" id="remarks" pattern="\\d*" placeholder="" class="myNumberSG" value=""/>
                        <!-- <span class="input-clear-button"></span> -->
                      </div>
                      <div class="col-20">
                        <button class="button button-fill sheet-open" data-sheet=".my-sheet-swipe-to-close" style="position:relative;right: -3px;width:30px;height:40px">FAV</button>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div> 

          <div class="sheet-modal my-sheet-swipe-to-close" style="height:auto; --f7-sheet-bg-color: #fff;">
            <div class="toolbar">
              <div class="toolbar-inner">
                <div class="left">
                  <a href="#" class="button button-fill color-orange" style="color:maroon; margin-left: 10px;" @click=${fav_add}>
                    
                      <span class='en'>Add Number</span>
                      <span class='cn'>加号码</span>
                      <span class='tl'>Númeru tan</span>
                    
                  </a>
                </div>
                <div class="right">
                  <a href="#" class="link sheet-close">
                    <span class='en'>Close</span>
                    <span class='cn'>关闭</span>
                    <span class='tl'>Taka</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="sheet-modal-inner">
              <!-- <div class="page-content"> -->
                <div class="card data-table" style="margin: 0px; border-radius: 0px;">
                  <table>
                    <thead>
                      <tr>
                        <th class="label-cell">
                          <span class='en'>User Phone</span>
                          <span class='cn'>用户电话</span>
                          <span class='tl'>Telemovel</span>
                        </th>
                        <th>
    
                        </th>
                        <th class="numeric-cell">
                          <span class='en'>Action</span>
                          <span class='cn'>行动</span>
                          <span class='tl'>Asaun</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody class="fav-list">
     
                    </tbody>
                  </table>
                </div>
              <!-- </div> -->
            </div>
          </div>

          <div class="list no-hairlines no-hairlines-between web-sg" style="margin-left:0px;background-color: transparent;margin-top: -30px; display:none">
            <ul style="background-color:transparent">
              <li class="item-content item-input item-input-outline">
                <div class="item-inner">
                  <div class="item-title item-floating-label">Code</div>
                  <div class="item-input-wrap">
                    <input type="number" pattern="\\d*" id="smsnum" placeholder="Buyer Code" class="myNumberSG"/>
                    <span class="input-clear-button"></span>
                  </div>
                </div>
              </li>
            </ul>
          </div> 


      <div class="list simple-list no-hairlines no-hairlines-between" style="width: 120px; background-color: transparent;margin-top: -25px;">
        <ul style="border-radius: 20px; background-color: transparent;">
          <li style="height: 30px;">
            <img src="static/images/gd.png" width=30px/>
            <!-- <label class="toggle"> -->
              <input type="checkbox" id="provider2"/>
              <!-- <span class="toggle-icon"></span> -->
            <!-- </label> -->
          </li>
        </ul>
      </div>
      <!-- ENTER PHONE NUMBER AND OPTION FOR OTHER PROVIDER END -->
    
      <p class="segmented block" style="margin-top: -10px;">
                <button style="height: 60px; font-size: 16px;" class="button button-outline" @click=${lucky}>
          <span class='en'>Lucky Pick</span>
          <span class='cn'>幸运之选</span>
          <span class='tl'>Sorte Pick</span>
        </button> 
                <button style="height: 60px; font-size: 16px;" class="button button-outline" @click=${addmoreButton}>
          <span class='en'>Add More</span>
          <span class='cn'>添加更多</span>
          <span class='tl'>AUMENTA</span>
        </button>  
                <button style="height: 60px; font-size: 16px;" class="button button-fill button-active" @click=${send}>
          <span class='en'>Submit</span>
          <span class='cn'>提交</span>
          <span class='tl'>Hatama</span>
        </button>
        <span class="segmented-highlight"></span>
      </p>
  
    </div>
  </div>
  `
    }
    ;
}

framework7Component.id = 'bb5784ca42';
export default framework7Component;